/* eslint-disable @typescript-eslint/camelcase */
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import {
    AccountCart,
    AccountCart_GiftCard,
    AccountCart_Payment,
    AccountCart_Shipmethod,
    AccountCart_ShippingAddress,
    Account_PaypalReviewOrder,
} from './account-cart.service';
import {
    Account,
    Account_BillingAddress,
    Account_BillingAsDefaultShippingAddress,
    Account_CreditCard,
    Account_NewsletterSubscription,
    Account_Password,
    Account_SecurityQuestion,
    Account_ShippingAddress,
    NewsletterSubscription,
    PasswordInfo,
    PasswordReset,
    PasswordReset_Update,
    PasswordVerify,
} from './account.service';
import { Analytics_ExactTarget } from './analytics.service';
import { Brand, Category } from './brand.service';
import {
    Cart,
    CartLine,
    Carts_ProductCount,
    Cart_Installment,
    Cart_Promocode,
    Cart_ProvincialTaxes,
} from './cart.service';
import { SemafoneConfig } from './config.service';

import { Favourites } from './favourite.service';
import { GiftCardBalance } from './giftcard.service';
import { Menu } from './menu.service';
import {
    ModifyOrder,
    Order,
    OrderInvoice,
    OrderedCart,
    OrderList,
    OrderReview,
    Order_EasypaySchedule,
} from './order.service';
import {
    Products,
    ProductsByItemNos,
    Products_Donation,
    Products_RecentlyAired,
    Products_Sections,
    Products_SectionsByTabOrder,
    Products_Shares,
    Products_StyleCodes,
    Products_TodayShowStopper,
    Products_WhatsOnAir,
} from './product.service';
import { ShowLinks, Shows, WatchUsLive } from './show.service';
import { SignIn } from './signin.service';
import { TscCreditCardApplication, TscCreditCardSecurityQuestion } from './tsccreditcardapplication.service';
import { UpsLocator } from './upslocator.service';


export class TscAPI {
    private _http: Http;

    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    constructor(private http: Http) {
        this._http = http;
    }

    get signin(): SignIn {
        return new SignIn(this._http);
    }

    get accounts(): Account {
        return new Account(this._http);
    }

    get accounts_BillingAddress(): Account_BillingAddress {
        return new Account_BillingAddress(this._http);
    }

    get accounts_BillingAsDefaultShippingAddress(): Account_BillingAsDefaultShippingAddress {
        return new Account_BillingAsDefaultShippingAddress(this._http);
    }

    get password_Reset(): PasswordReset {
        return new PasswordReset(this._http);
    }

    get password_Reset_Update(): PasswordReset_Update {
        return new PasswordReset_Update(this._http);
    }

    get password_Verify(): PasswordVerify {
        return new PasswordVerify(this._http);
    }

    get password_Info(): PasswordInfo {
        return new PasswordInfo(this._http);
    }

    get accounts_ShippingAddress(): Account_ShippingAddress {
        return new Account_ShippingAddress(this._http);
    }

    get accounts_Password(): Account_Password {
        return new Account_Password(this._http);
    }
    get accounts_SecurityQuestion(): Account_SecurityQuestion {
        return new Account_SecurityQuestion(this._http);
    }
    get accounts_NewsletterSubscription(): Account_NewsletterSubscription {
        return new Account_NewsletterSubscription(this._http);
    }
    get newsletterSubscription(): NewsletterSubscription {
        return new NewsletterSubscription(this._http);
    }
    get accounts_CreditCard(): Account_CreditCard {
        return new Account_CreditCard(this._http);
    }

    get carts(): Cart {
        return new Cart(this._http);
    }

    get carts_CartLines(): CartLine {
        return new CartLine(this._http);
    }

    get carts_Promocode(): Cart_Promocode {
        return new Cart_Promocode(this._http);
    }

    get carts_Installment(): Cart_Installment {
        return new Cart_Installment(this._http);
    }
    get carts_ProvincialTaxes(): Cart_ProvincialTaxes {
        return new Cart_ProvincialTaxes(this._http);
    }

    get accountcart(): AccountCart {
        return new AccountCart(this._http);
    }

    get accountcart_Shipmethod(): AccountCart_Shipmethod {
        return new AccountCart_Shipmethod(this._http);
    }

    get accountcart_Payment(): AccountCart_Payment {
        return new AccountCart_Payment(this._http);
    }

    get accountcart_ShippingAddress(): AccountCart_ShippingAddress {
        return new AccountCart_ShippingAddress(this._http);
    }

    get accountcart_GiftCard(): AccountCart_GiftCard {
        return new AccountCart_GiftCard(this._http);
    }

    get products(): Products {
        return new Products(this._http);
    }

    get products_RecentlyAired(): Products_RecentlyAired {
        return new Products_RecentlyAired(this._http);
    }

    get products_WhatsOnAir(): Products_WhatsOnAir {
        return new Products_WhatsOnAir(this._http);
    }

    get productsByItemNos(): ProductsByItemNos {
        return new ProductsByItemNos(this._http);
    }

    get products_Sections(): Products_Sections {
        return new Products_Sections(this._http);
    }

    get products_SectionsByTabOrder(): Products_SectionsByTabOrder {
        return new Products_SectionsByTabOrder(this._http);
    }

    get products_Shares(): Products_Shares {
        return new Products_Shares(this._http);
    }

    get products_TodayShowStopper(): Products_TodayShowStopper {
        return new Products_TodayShowStopper(this._http);
    }

    get products_StyleCodes(): Products_StyleCodes {
        return new Products_StyleCodes(this._http);
    }

    get products_Donation(): Products_Donation {
        return new Products_Donation(this._http);
    }

    get menu(): Menu {
        return new Menu(this._http);
    }
    get giftcardBalance(): GiftCardBalance {
        return new GiftCardBalance(this._http);
    }
    get order(): Order {
        return new Order(this._http);
    }
    get orderreview(): OrderReview {
        return new OrderReview(this._http);
    }

    get orderlist(): OrderList {
        return new OrderList(this._http);
    }

    get orderedCart(): OrderedCart {
        return new OrderedCart(this._http);
    }
    get order_EasypaySchedule(): Order_EasypaySchedule {
        return new Order_EasypaySchedule(this._http);
    }
    get modifyOrder(): ModifyOrder {
        return new ModifyOrder(this._http);
    }
    get orderInvoice(): OrderInvoice {
        return new OrderInvoice(this._http);
    }
    get tscCreditCardApplication(): TscCreditCardApplication {
        return new TscCreditCardApplication(this._http);
    }
    get tscCreditCardSecurityQuestion(): TscCreditCardSecurityQuestion {
        return new TscCreditCardSecurityQuestion(this._http);
    }

    get carts_ProductCount(): Carts_ProductCount {
        return new Carts_ProductCount(this._http);
    }

    get shows(): Shows {
        return new Shows(this._http);
    }

    get showLinks(): ShowLinks {
        return new ShowLinks(this._http);
    }

    get watchUsLive(): WatchUsLive {
        return new WatchUsLive(this._http);
    }

    get favourites(): Favourites {
        return new Favourites(this._http);
    }

    get semafoneConfig(): SemafoneConfig {
        return new SemafoneConfig(this._http);
    }

    get brand(): Brand {
        return new Brand(this._http);
    }
    get category(): Category {
        return new Category(this._http);
    }

    get accountCart_PaypalPayment(): Account_PaypalReviewOrder {
        return new Account_PaypalReviewOrder(this._http);
    }

    get analytics_ExactTarget(): Analytics_ExactTarget {
        return new Analytics_ExactTarget(this._http);
    }

    get ups_Locator(): UpsLocator {
        return new UpsLocator(this.http);
    }
static ctorParameters() { return [ { type: Http } ]; }}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/tscapi.service.ts